<div class="hidden-range-inputs">
	<mat-date-range-input [rangePicker]="picker">
		<input matStartDate [value]="_startDate" (dateChange)="onStartDateChange($event)" />
		<input matEndDate [value]="endDate" />
	</mat-date-range-input>
</div>

<div class="input-group">
	<input [id]="id" [name]="id"
		[ngClass]="['form-control', disabled ? '' : 'active-disabled']"
		disabled
		[(ngModel)]="weekAsString"
		 />
	<mat-date-range-picker #picker></mat-date-range-picker>
	<div class="input-group-addon datepicker-addon">
		<mat-datepicker-toggle matSuffix [for]="picker" [disableRipple]="true" [disabled]="disabled">
			<i matDatepickerToggleIcon class="fa fa-calendar"></i>
		</mat-datepicker-toggle>
		<a href="#" onclick="return false;" title="Retirer" (click)="onWeekDeletionRequest()">
			<span class="fa fa-minus-circle fa-lg adjust-delete-icon"></span>
		</a>
	</div>
</div>
